/**
 * 銀行口座種別のラベルを取得する / Get the bank account type label
 * @param bankAccountType 口座種別 / Bank account type
 * @param t 翻訳関数 / Translation function
 * @returns 口座種別のラベル / Bank account type label
 */
export const getBankAccountTypeLabel = (
  bankAccountType: string,
  t: (key: string) => string
): string => {
  switch (bankAccountType) {
    case 'ordinary':
      return t('instant_payee_bank_type_label_ordinary');
    case 'checking':
      return t('instant_payee_bank_type_label_checking');
    case 'saving':
      return t('instant_payee_bank_type_label_saving');
    case 'other':
      return t('instant_payee_bank_type_label_other');
    default:
      return bankAccountType;
  }
};
